const State = {
  loadXlsx: false,
};

module.exports = State;
